module.exports = __webpack_public_path__ + "static/media/RevealIcon2@2x.a754296e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ittybittyapps/RevealIcon2@2x.png
// module id = 71
// module chunks = 0